/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AuthService from "../../base/services/authentication.service";
import Login from "./login/Login.jsx";
import Registration from "./register/Registration.jsx";
import AuthLayout from "./layout/AuthLayout";
import LastPage from "./messagePages/LastPage";
import RequestPage from "./messagePages/RequestPage";
import FreeTrialSuccessfulPage from "./payment/FreeTrialSuccessfulPage.jsx";
import ForgotPassword from "./forgot-password/ForgotPassword.jsx";
import { withErrorBoundary } from "../../components/ErrorBoundary/withErrorBoundary.jsx";
import { rememberBillingEmailLink } from "../../components/Billing/billingEmailLink";
/* route protection will be applied after regist / auth apis are connected */
import "../../assets/styles/login-1.css";

// Every other address asks for a login first. A billing email's link is kept
// for it, so the login goes on to it (components/Billing/billingEmailLink.js).
//
// A login that has just finished navigates while the routes still think
// nobody is signed in (they read it in an effect, a render behind), so this is
// rendered once for the address the login went on to. Nothing is done then:
// the next render opens that address.
function ToLogin() {
   const location = useLocation();
   const isSignedIn = AuthService.isAuthenticated();

   useEffect(() => {
      if (!isSignedIn) rememberBillingEmailLink(location.pathname, location.search);
   }, [isSignedIn, location.pathname, location.search]);

   return isSignedIn ? null : <Navigate to="/auth/login" />;
}

function AuthPage() {
   const [isAuthorized, setisAuth] = useState(false);

   const location = useLocation();

   useEffect(() => {
      setisAuth(AuthService.isAuthenticated());
   }, [location, setisAuth]);

   return (
      <>
         <Routes>
            {isAuthorized ? (
               <Route path="/*" element={<Navigate to="/" />} />
            ) : (
               <>
                  <Route element={<AuthLayout />}>
                     <Route path="/auth/login" element={<Login />} />
                     <Route path="/auth/registration" element={<Registration />} />
                     <Route path="/*" element={<ToLogin />} />
                  </Route>
                  <Route path="/auth/forgot-password" element={<ForgotPassword />} />
                  <Route path="/auth/success" element={<LastPage />} />
                  <Route path="/auth/request" element={<RequestPage />} />
                  <Route path="/auth/freeTrial/successful" element={<FreeTrialSuccessfulPage />} />
               </>
            )}
         </Routes>
      </>
   );
}

const AuthPageWithErrorBoundary = withErrorBoundary(AuthPage);
export { AuthPageWithErrorBoundary as AuthPage };
